import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Col, Form, Input, InputNumber, Row } from 'antd';
import { GetById_Price_Api, Update_Price_Api } from '../../API/PriceApi';
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// -----------------------------------------------------------
// وارد کردن DatePicker و تنظیمات شمسی (جایگزین antd-jalali)
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------


// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim(); 

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-"); 
};

// =================================================================
/**
 * آداپتور سفارشی برای اتصال react-multi-date-picker به Form.Item آنت‌دیزاین.
 * خروجی همیشه YYYY-MM-DD با ارقام انگلیسی است.
 */
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    const toDateObject = (dateString) => {
        if (!dateString) return null;
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    useEffect(() => {
        // تنظیم مقدار اولیه از Form.Item (که از سرور لود شده)
        setDateValue(toDateObject(value));
    }, [value]);

    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);
            // تبدیل ارقام فارسی به انگلیسی در لحظه خروج
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره) به Form.Item
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT} 
        />
    );
};
// =================================================================

export const EditPriceComponent = ({ id, setLoading, showMessage, rowUpdated, cancelEdit }) => {
    // =================================================================
    const [price, setPrice] = useState();
    
    // State های قبلی مربوط به datepicker حذف شدند زیرا اکنون از آداپتور Form.Item استفاده می‌کنیم
    
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        loadData();
    }, [id]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_Price_Api(id);
            setLoading(false);
            if (data.messageStatus === "Successful") {
                const priceData = data.messageData.data;
                setPrice(priceData);
                
                // تنظیم مقادیر فیلدها در Form.Item
                // from_Shamsi و to_Shamsi نیز تنظیم می‌شوند و توسط آداپتور استفاده خواهند شد
                form.setFieldsValue(priceData); 

            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            // مقادیر from_Shamsi و to_Shamsi توسط PersianDatePickerAdapter به صورت YYYY-MM-DD انگلیسی تنظیم شده‌اند
            // پس نیازی به اضافه کردن مجدد آنها از State نیست.
            let data = await Update_Price_Api(values);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        // !!! رفع مشکل رندر آبجکت خطا: تبدیل آبجکت خطا به رشته
        const errorFields = errorInfo.errorFields;
        let errorMessage = "خطا در تکمیل فرم. فیلدهای زیر مشکل دارند: \n";
        
        if (errorFields && errorFields.length > 0) {
            errorFields.forEach(field => {
                const fieldName = field.name.join(' '); 
                const fieldErrors = field.errors.join(' | '); 
                errorMessage += `\n ${fieldName}: ${fieldErrors}`;
            });
        } else {
             errorMessage = "خطا در تکمیل فرم: " + JSON.stringify(errorInfo);
        }

        showMessage(errorMessage, "error");
    };
    // =================================================================
    // توابع initFromDateShamsi و initToDateShamsi حذف شدند زیرا دیگر نیازی به dayjs نیست.
    // =================================================================
    
    return (
        <>
            {price ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {price.title}
                        </h2>
                    </div>

                    <div className='container'>
                        <Form
                            form={form}
                            labelCol={{ span: 3 }}
                            wrapperCol={{ span: 21 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >

                            <Form.Item name="id" hidden={true} />
                            
                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ required: true, message: 'لطفاً عنوان را وارد کنید!' }]}
                            >
                                <Input placeholder='عنوان' />
                            </Form.Item>
                            
                            {/* جایگزین DatePickerJalali با PersianDatePickerAdapter */}
                            <Form.Item
                                name="from_Shamsi"
                                label="از تاریخ"
                                rules={[{ required: true, message: 'لطفاً تاریخ شروع را انتخاب کنید!' }]}
                            >
                                <PersianDatePickerAdapter />
                            </Form.Item>

                            <Form.Item
                                name="to_Shamsi"
                                label="تا تاریخ"
                                rules={[{ required: true, message: 'لطفاً تاریخ پایان را انتخاب کنید!' }]}
                            >
                                <PersianDatePickerAdapter />
                            </Form.Item>
                            
                            <Form.Item name="categoryId" hidden={true} />
                            
                            <Form.Item
                                label="هزینه ثابت"
                                name="fix"
                                rules={[{ required: true, message: 'لطفاً هزینه ثابت را وارد کنید!' }]}
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                            
                            <Form.Item
                                label="هزینه هر نفر"
                                name="perPerson"
                                rules={[{ required: true, message: 'لطفاً هزینه هر نفر را وارد کنید!' }]}
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                            
                            <Form.Item
                                label="هزینه نفر اضافی"
                                name="extraPerson"
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>
                            
                            <Form.Item
                                label="هزینه کودک"
                                name="perChild"
                            >
                                <InputNumber style={{ width: '100%' }} min={0} />
                            </Form.Item>

                            <Form.Item
                                name="orderIndex"
                                label="ترتیب"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="isActive"
                                label="فعال"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>
                        </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}